import React, { useMemo } from 'react';
import { pickRandomMiniGame } from './minigames';

// The full-cover "we're evaluating" overlay over the game overlay, with a random mini-game for the
// wait. When the evaluation finishes the modal reloads and this unmounts.
export default function EvaluationLoader(): React.ReactNode {
  // Pick once per open, not per render.
  const game = useMemo(() => pickRandomMiniGame(), []);
  const Game = game.Component;

  return (
    <div className="cm-eval-loader" role="alertdialog" aria-label="Evaluating game">
      <div className="cm-eval-loader-card">
        <div className="cm-eval-loader-head">
          <span className="cm-eval-loader-spin" aria-hidden="true" />
          <div>
            <div className="cm-eval-loader-title">Reading your game with the engine…</div>
            <div className="cm-eval-loader-sub">
              This usually takes about 10 seconds. Here&apos;s something to play while you wait.
            </div>
          </div>
        </div>

        <div className="cm-eval-loader-bar" aria-hidden="true">
          <span />
        </div>

        <div className="cm-eval-loader-game">
          <div className="cm-eval-loader-game-name">{game.name}</div>
          <Game />
        </div>

        <div className="cm-eval-loader-foot">
          We&apos;ll drop you back into your game the moment it&apos;s ready.
        </div>
      </div>
    </div>
  );
}
